export const eurCurrency = {
  code: "EUR",
};
